<div class='admissions-overview-tab1-part'>
	This is tab 1
</div>